export default __webpack_public_path__ + "static/media/Sova-Lineup (1).dc95ff2b.png";